import { post } from "./fetch.core";
import { Reward } from "../types/reward";
import useAdminShop from "../hooks/useAdminShop";
import { OrderAmount } from "../types/checkout";
import { get } from "./fetch.core";

async function getRewards(userId: string) {
  const res = await post<Reward[]>(`/pos/rewardRecord/list`, { userId });
  return res.data;
}

function useCalculateDeductible(itemsTotal: number, shippingTotal: number, tax: number): number {
  const shop = useAdminShop();

  if (!shop) {
    return 0;
  }

  let totalDeductible: number = 0;
  if (shop.rewardAppliesTo.includes("order")) {
    totalDeductible += itemsTotal;
  }
  if (shop.rewardAppliesTo.includes("shipping")) {
    totalDeductible += shippingTotal;
  }
  if (shop.rewardAppliesTo.includes("tax")) {
    totalDeductible += tax;
  }
  if (shop.minOrderAmtAfterDeduct > 0) {
    totalDeductible -= shop.minOrderAmtAfterDeduct;
  }

  return totalDeductible;
}

export const useRewardValue = (checked: boolean, userRewardPoints: number, total: OrderAmount): number => {
  const { itemsTotal, tax } = total;
  const shippingTotal = (total.shipping ?? 0) + (total.shippingExtra ?? 0);
  const totalDeductible = useCalculateDeductible(itemsTotal, shippingTotal, tax);

  if (checked) {
    return userRewardPoints > totalDeductible ? totalDeductible : userRewardPoints;
  }
  return 0;
};

const rewardCore = {
  getRewards,
  useRewardValue,
};

export default rewardCore;
